import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=8005ea0a&scoped=true&"
import script from "./Template4.vue?vue&type=script&lang=js&"
export * from "./Template4.vue?vue&type=script&lang=js&"
import style0 from "./Template4.vue?vue&type=style&index=0&id=8005ea0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8005ea0a",
  null
  
)

export default component.exports